export function getHeroImageSmallResPath(originalPath, resolutionPostfix = '_xs') {
  const pattern = /^(.*\/)(.*)\.([a-z0-9]+)$/i;
  const parts = pattern.exec(originalPath);
  if (parts === null) {
    return originalPath;
  }
  const [, prePath, filename, extension] = parts;;
  return `${prePath}${filename}${resolutionPostfix}.${extension}`;
}
